import { Channel } from '../types/channels';

export const validateChannelName = (
  name: string,
  currentChannels: Channel[],
  editingChannelName: string | null
): string | null => {
  const normalizedName = name.toLowerCase().trim();

  if (normalizedName === 'general') {
    return '"General" is a reserved channel name. Please choose a different name.';
  }

  const isDuplicate = currentChannels.some((channel) => {
    const isInEditMode = editingChannelName !== null;
    const isEditingTheSameChannel =
      isInEditMode && channel.displayName === editingChannelName;
    if (isInEditMode && isEditingTheSameChannel) {
      return false;
    }
    return channel.displayName.toLowerCase().trim() === normalizedName;
  });

  if (isDuplicate) {
    return 'A channel with this name already exists';
  }

  return null;
};
